import React from "react";

interface UnmatchedEmployeeWarningProps {
  names: string[];
}

/**
 * Displays a warning when some Excel employee names could not be matched
 * to a system employee record. Renders nothing when names list is empty.
 */
const UnmatchedEmployeeWarning: React.FC<UnmatchedEmployeeWarningProps> = ({ names }) => {
  if (names.length === 0) return null;

  return (
    <div className="mt-3 flex gap-3 rounded-lg border border-yellow-300 bg-yellow-50 p-3 text-sm text-yellow-800">
      <svg
        className="mt-0.5 h-5 w-5 flex-shrink-0 text-yellow-500"
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path
          fillRule="evenodd"
          d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
          clipRule="evenodd"
        />
      </svg>
      <div>
        <p className="font-semibold">
          {names.length} employee{names.length > 1 ? "s" : ""} not found in the system — {names.length > 1 ? "their rows" : "this row"} will be skipped on import.
        </p>
        <p className="mt-0.5 text-xs text-yellow-700">
          {names.map((n) => `"${n}"`).join(", ")}
        </p>
      </div>
    </div>
  );
};

export default UnmatchedEmployeeWarning;
